import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_BUS_CHASSIS,
  CLEAR_BUSES_CHASSIS,
  FLAG_BUS_CHASSIS_ACTIVITY,
  FLAG_GETTING_BUSES_CHASSIS,
  GET_BUS_CHASSIS,
  GET_BUSES_CHASSIS,
} from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    loading: Immutable.List(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_BUSES_CHASSIS:
      return state.setIn(['all', 'loading'], payload);
    case GET_BUSES_CHASSIS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_BUSES_CHASSIS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case GET_BUS_CHASSIS:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case FLAG_BUS_CHASSIS_ACTIVITY:
      // raising flag
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }
      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case CLEAR_BUS_CHASSIS:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
